import { Directive, EventEmitter, Input, OnInit, Output, Type, ViewContainerRef, inject } from "@angular/core";
import { ExtraPropertiesFieldComponent } from "../components/extra-properties-field/extra-properties-field.component";

@Directive({
  selector: "[appExtraPropertiesOutlet]",
  standalone: true,
})
export class ExtraPropertiesOutletDirective implements OnInit {
  private vcr = inject(ViewContainerRef);

  @Input("appExtraPropertiesOutlet") componentType!: Type<ExtraPropertiesFieldComponent>;
  @Output() created = new EventEmitter<ExtraPropertiesFieldComponent>();

  public ngOnInit(): void {
    const ref = this.vcr.createComponent(this.componentType);
    this.created.emit(ref.instance);
  }
}
